/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Intervals_DescInputs */

const en_ui_onboarding_intervals_desc = /** @type {(inputs: Ui_Onboarding_Intervals_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect once — new sessions sync in`)
};

const de_ui_onboarding_intervals_desc = /** @type {(inputs: Ui_Onboarding_Intervals_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmal verbinden – synct automatisch`)
};

/**
* | output |
* | --- |
* | "Connect once — new sessions sync in" |
*
* @param {Ui_Onboarding_Intervals_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_intervals_desc = /** @type {((inputs?: Ui_Onboarding_Intervals_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Intervals_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_intervals_desc(inputs)
	return de_ui_onboarding_intervals_desc(inputs)
});